import { Link } from 'react-router-dom';

export default function ComparisonSection() {
  return (
    <section className="py-24 md:py-32 bg-background-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex flex-col lg:flex-row items-start gap-6 mb-16">
          <div className="lg:w-1/3">
            <span className="text-xs font-semibold text-foreground-500 uppercase tracking-widest">
              OOP
            </span>
            <span className="block text-xs font-light text-foreground-400 uppercase tracking-widest">
              Buy
            </span>
          </div>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-[1.15]">
            Spreadsheet vs<br />Traditional Agent
          </h2>
        </div>

        {/* Three Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {/* Card 1: Problems */}
          <div className="rounded-2xl bg-foreground-950 p-8 md:p-10 flex flex-col">
            <div className="w-11 h-11 rounded-full bg-foreground-800 flex items-center justify-center mb-8">
              <i className="ri-close-line text-xl text-background-50"></i>
            </div>
            <h3 className="text-xl font-heading font-bold text-background-50 mb-6">
              Traditional Agent Pain Points
            </h3>
            <ul className="space-y-4 flex-1">
              {[
                'Hidden pricing and unclear fee structures',
                'Slow communication with delayed responses',
                'Confusing ordering process with many steps',
                'Lack of transparency throughout sourcing',
              ].map((item, i) => (
                <li key={i} className="flex items-start gap-3 text-background-50/70 text-sm leading-relaxed">
                  <span className="text-accent-500 mt-0.5 flex-shrink-0">
                    <i className="ri-close-circle-line"></i>
                  </span>
                  {item}
                </li>
              ))}
            </ul>
            <p className="text-foreground-500 text-xs mt-8 border-t border-foreground-800 pt-5">
              Common issues reported by buyers
            </p>
          </div>

          {/* Card 2: OOPBuy Advantage */}
          <div className="rounded-2xl overflow-hidden relative flex flex-col min-h-[420px]">
            <img
              src="https://readdy.ai/api/search-image?query=Clean%20modern%20spreadsheet%20and%20product%20organizer%20displayed%20on%20light%20cream%20studio%20desk%20with%20organized%20fashion%20items%20around%20minimalist%20workspace%20photography%20soft%20natural%20daylight%20editorial%20aesthetic%20high%20detail&width=800&height=1000&seq=compare-advantage-01&orientation=portrait"
              alt="OOPBuy Advantage"
              className="absolute inset-0 w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-primary-900/55"></div>
            <div className="relative z-10 flex flex-col flex-1 p-8 md:p-10">
              <span className="inline-block px-3 py-1 rounded-full bg-accent-400/30 text-background-50 text-xs font-semibold mb-8 self-start">
                OOPBuy Advantage
              </span>
              <div className="mt-auto">
                <h3 className="text-3xl font-heading font-bold text-background-50 mb-3">
                  Transparent &amp; Fast
                </h3>
                <p className="text-background-50/80 text-sm leading-relaxed">
                  Clear product listings in spreadsheet format with direct pricing, organized categories, and streamlined agent workflow.
                </p>
              </div>
            </div>
          </div>

          {/* Card 3: Data Point */}
          <div className="rounded-2xl bg-background-50 border border-background-200/70 p-8 md:p-10 flex flex-col justify-between">
            <div>
              <span className="text-[80px] md:text-[96px] font-heading font-bold text-primary-500 leading-none block">
                100%
              </span>
              <span className="text-2xl font-heading font-bold text-foreground-950 block mt-1">
                Clear
              </span>
              <p className="text-foreground-600 text-sm mt-4 leading-relaxed">
                Every price, every product detail, every tracking update — visible from the moment you open the spreadsheet. No hidden costs, no surprises.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-background-200">
              <div className="flex items-center gap-2 text-accent-600">
                <i className="ri-bar-chart-2-line text-lg"></i>
                <span className="text-xs font-semibold">Data-driven sourcing</span>
              </div>
            </div>
          </div>
        </div>

        {/* CTA under comparison */}
        <div className="mt-12 text-center">
          <Link
            to="/blog/what-is-oopbuy-spreadsheet"
            className="inline-flex items-center gap-2 px-6 py-3.5 rounded-full bg-primary-500 hover:bg-primary-600 transition-colors text-background-50 font-semibold text-sm whitespace-nowrap cursor-pointer"
          >
            See Full Comparison Details
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}